/**
 * Directive: priceListPicker
 */
angular.module('acme.common.directive.priceListPicker', [
  'ui.grid',
  'acme.common.service.api',
  'acme.common.service.helpers'
])
.directive('priceListPicker', [ '$timeout', 'ApiService', 'HelpersService', 'uiGridConstants', function($timeout, ApiService, HelpersService, uiGridConstants) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/priceListPicker/priceListPicker.tpl.html',
      scope: {
        hideChannels: '@',
        selectedPriceList: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        $scope.priceListPicker.init();
      },

      controller: ['$scope', function($scope) {

        $scope.priceListPicker = {

          model: [],
          selected: {},
          selectedPriceList: {},
          gridHeight: {
            height: '42px'
          },

          gridOptions: {
            enableRowSelection: false,
            multiSelect: false,
            paginate: false,
            showFooter: false
          },

          columns: [
            {
              field: 'personType.displayOrder',
              displayName: 'Order',
              visible: false
            },
            {
              field: 'personType.name',
              displayName: 'Ticket Type',
              sort: {
                direction: uiGridConstants.ASC
              }
            },
            {
              field: 'personType.description',
              displayName: 'Description'
            },
            {
              field: 'price',
              displayName: 'Price',
              cellFilter: 'currency',
              enableCellEdit: true
            },
            {
              field: 'salesChannels[0].enabled',
              displayName: 'Web',
              cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /></div>',
              visible: true
            },
            {
              field: 'salesChannels[1].enabled',
              displayName: 'POS',
              cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /></div>',
              visible: true
            },
            {
              field: 'salesChannels[2].enabled',
              displayName: 'Reseller',
              cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /></div>',
              visible: true
            }
          ],

          isLoaded: false,

          init: function() {
            $scope.$watch('priceListPicker.selected', this.onPriceListPickerSelectedUpdate);
            if ($scope.hideChannels) {
              this.columns[4].visible = false;
              this.columns[5].visible = false;
              this.columns[6].visible = false;
            }
            this.getPriceLists();
          },

          getPriceLists: function() {
            ApiService.price.lists.list(HelpersService.getPaginator()).then(this.success.getPriceLists, this.error.getPriceLists);
          },

          findPriceList: function(id) {
            var i, ii,
                r = false;

            for (i=0,ii=this.model.length;i<ii;i++) {
              if (this.model[i].id === id) {
                r = {
                  index: i,
                  list: this.model[i]
                };
                break;
              }
            }

            return r;
          },

          replacePriceList: function(list) {
            var replace = this.findPriceList(list.id);

            this.model[replace.index] = list;

            return replace.index;
          },

          hasPrices: function() {
            return ($scope.selectedPriceList && $scope.selectedPriceList.prices instanceof Array && $scope.selectedPriceList.prices.length > 0);
          },

          success: {
            getPriceLists: function(response) {
              var self = $scope.priceListPicker;

              self.model = response.data.payload.list;
              if ($scope.selectedPriceList) {
                $timeout(function() {
                  self.selected = self.model[self.replacePriceList($scope.selectedPriceList)];
                }, 10);
              }
            }
          },

          error: {
            getPriceLists: function() {}
          },

          onPriceListPickerSelectedUpdate: function(n, o) {
            var self = $scope.priceListPicker;

            console.log(n);

            if (n) {
              $scope.selectedPriceList = angular.copy(self.findPriceList(n.id).list);
            }else{
              $scope.selectedPriceList = [];
            }
          }

        };

      }]

    };

}]);